import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

import { RawContextKey, IContextKeyService } from '../../../platform/contextkey/common/contextkey.js';
import { dispose as _dispose, Disposable } from '../../../base/common/lifecycle.js';

var WordContextKey = /*#__PURE__*/function (_Disposable) {
  _inherits(WordContextKey, _Disposable);

  var _super = _createSuper(WordContextKey);

  function WordContextKey(_editor, contextKeyService) {
    var _this;

    _classCallCheck(this, WordContextKey);

    _this = _super.call(this);
    _this._editor = _editor;
    _this._enabled = false;
    _this._ckAtEnd = WordContextKey.AtEnd.bindTo(contextKeyService);

    _this._register(_this._editor.onDidChangeConfiguration(function (e) {
      return e.hasChanged(101
      /* tabCompletion */
      ) && _this._update();
    }));

    _this._update();

    return _this;
  }

  _createClass(WordContextKey, [{
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(WordContextKey.prototype), "dispose", this).call(this);

      _dispose(this._selectionListener);

      this._ckAtEnd.reset();
    }
  }, {
    key: "_update",
    value: function _update() {
      var _this2 = this;

      // only update this when tab completions are enabled
      var enabled = this._editor.getOption(101
      /* tabCompletion */
      ) === 'on';

      if (this._enabled === enabled) {
        return;
      }

      this._enabled = enabled;

      if (this._enabled) {
        var checkForWordEnd = function checkForWordEnd() {
          if (!_this2._editor.hasModel()) {
            _this2._ckAtEnd.set(false);

            return;
          }

          var model = _this2._editor.getModel();

          var selection = _this2._editor.getSelection();

          var word = model.getWordAtPosition(selection.getStartPosition());

          if (!word) {
            _this2._ckAtEnd.set(false);

            return;
          }

          _this2._ckAtEnd.set(word.endColumn === selection.getStartPosition().column);
        };

        this._selectionListener = this._editor.onDidChangeCursorSelection(checkForWordEnd);
        checkForWordEnd();
      } else if (this._selectionListener) {
        this._ckAtEnd.reset();

        this._selectionListener.dispose();

        this._selectionListener = undefined;
      }
    }
  }]);

  return WordContextKey;
}(Disposable);

WordContextKey.AtEnd = new RawContextKey('atEndOfWord', false);
WordContextKey = __decorate([__param(1, IContextKeyService)], WordContextKey);
export { WordContextKey };